import React from 'react';

import UiKitForm from '@hero/ui-kit/inputs/Form';
import * as Style from './style.module.scss';

type Props = React.ComponentProps<typeof UiKitForm> & {
    /** Denser fields: smaller height, type and spacing. */
    compact?: boolean;
};

/** ui-kit's Form with an optional compact density; everything else passes through. */
const Form: React.FC<Props> = ({ compact = false, ...rest }) =>
    compact ? (
        <div className={Style.compact}>
            <UiKitForm {...rest} />
        </div>
    ) : (
        <UiKitForm {...rest} />
    );

export default Form;
export { useFormContext, useFieldArray, useWatch, Controller } from '@hero/ui-kit/inputs/Form';
